<template>
	<div style="display: flex;flex-direction: row;height: 100vh;">
		<!-- 左边栏 -->
		<div class="leftDiv">

			<img src="@/img/user.png" class="userImg"/>
			<span class="shopName">{{name}}</span>
			<div style="display: flex;flex: 1;flex-direction: column;width: 100%;box-sizing: border-box;margin-top: 50px;">
				<div class="zImg" @click="toHomePage" :class="$route.fullPath.indexOf('homePage')>0?'mentActive':''">
					<div class="bjImg bgcolor">
						<img src="@/img/1.png" style="height: 20px;width: 20px;" alt="" />
					</div>
					<div class="bottowDiv"> 考勤统计</div>
				</div>
        <div class="zImg" @click="toRest" :class="$route.fullPath.indexOf('rest')>0?'mentActive':''">
        	<div class="bjImg bgcolor">
        		<img src="@/img/1.png" style="height: 20px;width: 20px;" alt="" />
        	</div>
        	<div class="bottowDiv"> 休息设置</div>
        </div>
<!--        <div class="zImg" @click="toSet" :class="$route.fullPath.indexOf('set')>0?'mentActive':''">
        	<div class="bjImg bgcolor">
        		<img src="@/img/1.png" style="height: 20px;width: 20px;" alt="" />
        	</div>
        	<div class="bottowDiv"> 系统设置</div>
        </div> -->
				<div class="zImg" @click="backLogin">
					<div class="bjImg bgcolor">
						<img src="@/img/5.png" style="height: 20px;width: 20px;" alt="" />
					</div>
					<div class="bottowDiv">退出</div>
				</div>
			</div>
		</div>

		<!-- 右边栏 -->
		<div style="flex: 1;overflow:auto;height: 100%;box-sizing: border-box;background-color: #F4F5F6;">
			<router-view></router-view>
		</div>

	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {
				name:'人力资源部'
			}
		},
		watch: {
			'$route.fullPath'(){
				console.log('route change')
			}
		},
		computed: {
			test(){
				let result = this.$router.currentRoute.fullPath;
				return result;
			}
		},
		methods: {
			//点击首页
			toHomePage(){
				this.$router.push('/main/homePage');
			},
			//点击休息设置
			toRest(){
				this.$router.push('/main/rest');
			},
      toSet(){
        this.$router.push('/main/set');
      },
			//退出
			backLogin() {
				this.$router.push('/')
			}
		},
		created() {},
		mounted() {

		}
	}
</script>
<style scoped>
	.leftDiv {
		min-width: 220px;
		overflow: auto;
		background-color: #51576d;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.userImg {
		width: 135px;
		height: 140px;
		margin-top: 40px;

	}

	.bottowDiv {
		font-size: 24px;
		margin-left: 15px;
		color: #FEFEFE;
		font-family: '微软雅不黑', '微软雅黑', '黑体', sans-serif;

	}

	.bjImg {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 36px;
		height: 38px;
		border-radius: 100%;
	}

	.zImg {
		display: flex;
		flex-direction: row;
		box-sizing: border-box;
		padding-left: 40px;
		align-items: center;
		height: 70px;
		/* flex: 1; */
		cursor: pointer;
		-webkit-app-region: no-drag;
	}

	.zImg:hover {
		background-color: rgba(0, 0, 0, 0.6);
	}
	.shopName{
		background-color: rgba(255,255,255,0.1);
		color: white;
		padding: 3px 10px;
		border-radius: 3px;
		margin-top: 15px;
	}

	.miniDiv{
		box-sizing: border-box;
		padding-top: 10px;
		padding-right: 10px;
		color: #eee;
		text-align: right;
		width: 100%;
	}
	.fsize{
		font-size: 12px;
		cursor: pointer;
		-webkit-app-region: no-drag;
		padding: 3px;
		border-radius: 50px;
	}
	.fsize:hover{
		color: white;
		background-color: #3A3A3A;
	}
</style>



// WEBPACK FOOTER //
// src/view/main.vue